import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { showToast } from "../notifications/notificationsSlice";
import type { AppDispatch, RootState } from "../../app/store";
import {
    clearMentorRecommendations,
    generateMentorRecommendations,
    hydrateMentorRecommendations,
    markRecommendedPageSeen,
    markRecommendationFiltersAdjusted,
} from "./mentorRecommendationsSlice";
import {
    deleteMentorRecommendations as deleteMentorRecommendationsApi,
    putMentorRecommendations as putMentorRecommendationsApi,
} from "../../api";

export const mentorRecommendationListenerMiddleware = createListenerMiddleware();

const startAppListening = mentorRecommendationListenerMiddleware.startListening.withTypes<RootState, AppDispatch>();

startAppListening({
    matcher: isAnyOf(
        markRecommendedPageSeen,
        markRecommendationFiltersAdjusted,
        generateMentorRecommendations.fulfilled,
    ),
    effect: async (_action, listenerApi) => {
        const state = listenerApi.getState();
        const userId = state.session.userId;
        const recommendations = state.mentorRecommendations.data;

        if (!userId || !recommendations) return;

        try {
            await putMentorRecommendationsApi(userId, recommendations);
        } catch (error) {
            console.error("Failed to persist mentor recommendations:", error);
            listenerApi.dispatch(
                showToast({
                    message: "Couldn't save recommendations.",
                    severity: "error",
                }),
            );
        }
    },
});

startAppListening({
    actionCreator: clearMentorRecommendations,
    effect: async (_action, listenerApi) => {
        const state = listenerApi.getState();
        const userId = state.session.userId;

        if (!userId) return;

        try {
            await deleteMentorRecommendationsApi(userId);
        } catch (error) {
            console.error("Failed to clear remote mentor recommendations:", error);
            listenerApi.dispatch(
                showToast({
                    message: "Couldn't clear recommendations.",
                    severity: "error",
                }),
            );
        }
    },
});

startAppListening({
    actionCreator: generateMentorRecommendations.rejected,
    effect: async (_action, listenerApi) => {
        listenerApi.dispatch(
            showToast({
                message: "Couldn't generate recommendations.",
                severity: "error",
            }),
        );
    },
});

startAppListening({
    actionCreator: hydrateMentorRecommendations.rejected,
    effect: async (_action, listenerApi) => {
        listenerApi.dispatch(
            showToast({
                message: "Couldn't restore recommendations.",
                severity: "error",
            }),
        );
    },
});
